import { link } from "@/components/Action.tsx";
import type { MetalListItemWithType } from "@/modules/metal/metalQuery.ts";

export function leaseLink({ uuid, location }: MetalListItemWithType) {
    return link({ to: "/metal/lease/$location/$uuid", params: { uuid, location } });
}

// XXX: This function is wrong, it should be `commitmentLink`
export function leaseUuidLink(uuid: string, location: string) {
    return link({ to: "/metal/lease/$location/$uuid", params: { uuid, location } });
}
